import axios from 'axios'
import clientDataFromFile from '../../data/Clients'

const STF_API_KEY= process.env.VUE_APP_STF_API_KEY

// Cognito ID token is attached to backend requests by src/auth/axiosAuth.js
export default {
  name: "EEPSEO_COM-API",

  data() {
    return {
      apiKey: 0,
      baseApiUrl: process.env.VUE_APP_BASE_GATEWAY_URL,
      publicApiUrl: process.env.VUE_APP_PUBLIC_GATEWAY_URL,
      proxyNoAuth: {
        headers: {
          Accept: "application/json",
          "x-api-key": STF_API_KEY,
        },
      },
      proxyNoAuthLongTimeout: {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-api-key": STF_API_KEY,
        },
        timeout: 8000,
      },
      mockApiClientData: [],
    };
  },
  created () {
  },

  methods: {

    async apiRetryProject (projectId) {
      try {
        const response = await axios.get(
            this.baseApiUrl + '/projects/'+projectId+'/retry',
            this.proxyNoAuth,
        );
        return response.data;
      } catch (error) {
        return this.processResponseError(error)
      }
    },
    
    async apiAddProject (payload) {
      try {
        // this.showLoader()
        const body = {
          ...payload
        };
        const response = await axios.post(
          this.baseApiUrl + '/projects',
          body,
          this.proxyNoAuth,
        );
        // this.hideLoader()
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiGetProjects () {
      try {
        const response = await axios.get(
          this.baseApiUrl + '/projects?fields=name&fields=status',
          this.proxyNoAuth,
        )
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiGetProjectData(id) {
      try {
        const response = await axios.get(
          this.baseApiUrl + `/projects/${id}`,
          this.proxyNoAuth
        )

        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiGetAccount (accountId) {
      try {
        const response = await axios.get(
          this.baseApiUrl + `/accounts/${accountId}`,
          this.proxyNoAuth,
        )
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiModifyAccount (accountId, payload) {
      try {
        const response = await axios.patch(
          this.baseApiUrl + `/accounts/${accountId}`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiGetAccountClients (accountId) {
      try {
        const response = await axios.get(
          this.baseApiUrl + `/accounts/${accountId}/clients`,
          this.proxyNoAuth,
        )
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiGetClients () {
      try {
        // this.showLoader()
        const response = await axios.get(
          this.baseApiUrl + '/clients?fields=name&fields=email&fields=phone&fields=status',
          this.proxyNoAuth,
        )
        // this.hideLoader()
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiModifyClient (clientId, payload) {
      try {
        const response = await axios.patch(
          this.baseApiUrl + `/clients/${clientId}`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },
    
    async apiCreateClientContact (clientId, payload) {
      try {
        const response = await axios.post(
          this.baseApiUrl + `/clients/${clientId}/contacts`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiDeleteClientContact (contactId) {
      try {
        const response = await axios.delete(
          this.baseApiUrl + `/clients/contacts/${contactId}`,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiModifyClientContact (contactId, payload) {
      try {
        const response = await axios.patch(
          this.baseApiUrl + `/clients/contacts/${contactId}`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiCreateClientDomain (clientId, payload) {
      try {
        const response = await axios.post(
          this.baseApiUrl + `/clients/${clientId}/domains`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiModifyClientDomain (domainId, payload) {
      try {
        const response = await axios.patch(
          this.baseApiUrl + `/clients/domains/${domainId}`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiDeleteClientDomain (domainId) {
      try {
        const response = await axios.delete(
          this.baseApiUrl + `/clients/domains/${domainId}`,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiCreateClientService (clientId, payload) {
      try {
        const response = await axios.post(
          this.baseApiUrl + `/clients/${clientId}/services`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiModifyClientService (serviceId, payload) {
      try {
        const response = await axios.patch(
          this.baseApiUrl + `/clients/services/${serviceId}`,
          payload,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiDeleteClientService (serviceId) {
      try {
        const response = await axios.delete(
          this.baseApiUrl + `/clients/services/${serviceId}`,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiGetGoogleAuthLink(accountId = '5d06629f4e20444ea87e12364c4fa9ef') {
      try {
        const response = await axios.get(
          this.publicApiUrl + `/google-oauth/url?account_id=${accountId}`,
          this.proxyNoAuth
        )
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiGetSeeds (data) {
      try {
        // this.showLoader()
        const response = await axios.post(
          this.baseApiUrl + '/generation/seeds',
          data,
          this.proxyNoAuthLongTimeout,
        )
        // this.hideLoader()
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiGetGscSiteList () {
      try {
        // this.showLoader()
        const response = await axios.get(
          this.baseApiUrl + '/providers/google/site-list',
          {
            ...this.proxyNoAuth,
            params: {
              accountId: '5d06629f4e20444ea87e12364c4fa9ef',
              serviceName: 'google',
            },
          }
        )
        return response.data
      } catch (error) {
        this.consoleLog('error', 'mainApi.js fn(apiGetGscSiteList): error catch', error)
        return this.processResponseError(error)
      }
    },

    async apiUpdateClient (payload, id) {
      try {
        // this.showLoader()
        const body = {
          ...payload
        };
        const response = await axios.put(
          this.baseApiUrl + '/clients/' + id,
          body,
          this.proxyNoAuth,
        );
        // this.hideLoader()
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiAddClient (payload) {
      try {
        // this.showLoader()
        const body = {
          ...payload
        };
        const response = await axios.post(
          this.baseApiUrl + '/clients',
          body,
          this.proxyNoAuth,
        );
        // this.hideLoader()
        return response.data
      } catch (error) {
        return this.processResponseError(error)
      }
    },

    async apiDeleteClient(contactId) {
      try {
        const response = await axios.delete(
          this.baseApiUrl + `/clients/${contactId}`,
          this.proxyNoAuth
        )
        return response.data;
      } catch (error) {
        return this.processResponseError
      }
    },

    async apiGetClientProjects(clientId) {
      try {
        const response = await axios.get(
          this.baseApiUrl + `/clients/${clientId}/projects`,
          this.proxyNoAuth,
        )
        return response.data
      } catch (error) {
        this.consoleLog('error', 'mainApi.js fn(apiGetClientData): error catch', error)
        return this.processResponseError(error);
      }
    },

    async apiGetClientData(clientId) {
      try {
        const response = await axios.get(
          this.baseApiUrl + `/clients/${clientId}`,
          this.proxyNoAuth,
        )
        return response.data
      } catch (error) {
        this.consoleLog('error', 'mainApi.js fn(apiGetClientData): error catch', error)
        return this.processResponseError(error);
      }
    },

    async apiGetIpAddress() {
      try {
        // if (this.mainStateGet('clientIpAddress') === '') {
        await fetch('https://api.ipify.org?format=json')
          .then(x => x.json())
          .then(({ ip }) => {
            this.mainStateSet('clientIpAddress', ip)
          })
        // }
      } catch (error) {
        this.consoleLog('error', 'mainApi.js fn(getIpAddress): error catch', error)
        return this.processResponseError(error);
      }
    },

    processResponseError(error) {
      this.hideLoader();
      axios.defaults.timeout = 0;
      
      // Check if error has a response with data
      if (error.response && error.response.data) {
        // Return the actual error response data, preserving the original message
        return {
          ...error.response.data,
          responseError: true,
          networkError: false
        };
      }
      
      // Fallback for network errors or other issues
      const response = { responseError: true, networkError: false };
      if (/network/gi.test(error)) response.networkError = true;
      return response;
    },

    showLoader() {
      window.dispatchEvent(
        new CustomEvent("loader", {
          bubbles: true,
          cancelable: true,
          detail: { value: true },
        })
      );
    },

    hideLoader() {
      window.dispatchEvent(
        new CustomEvent("loader", {
          bubbles: true,
          cancelable: true,
          detail: { value: false },
        })
      );
    },

  },
};
